import { CenteredFlexBox } from "@/components/layout/FlexBox"
import { fillColorPrimary500, width64px } from "@/components/style-utils"
import WavelengthRadio from "@/icons/WavelengthRadio.svg?react"
import styled from "@mui/material/styles/styled"

export const RadioSvg = styled(WavelengthRadio as React.FC)(({ theme }) => ({
  ...width64px,
  ...fillColorPrimary500(theme),
}))

const LoadingWavelengthRadio = () => {
  return <RadioSvg />
}

export const CenteredLoadingWavelengthRadio = () => {
  return (
    <CenteredFlexBox sx={{ width: 1, height: 1 }}>
      <RadioSvg />
    </CenteredFlexBox>
  )
}

export default LoadingWavelengthRadio
